import { Link } from "react-router-dom";
import { useReveal } from "@/hooks/useReveal";

export default function CTA() {
  const ref = useReveal<HTMLDivElement>();
  return (
    <section ref={ref} className="bg-cream pb-24 md:pb-32">
      <div className="mx-auto max-w-[1320px] px-6 md:px-10">
        <div
          className="relative rounded-[32px] overflow-hidden min-h-[520px] md:min-h-[640px] flex items-end"
          data-reveal
        >
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20modern%20technology%20background%20with%20soft%20flowing%20lines%20geometric%20shapes%20digital%20network%20connections%20warm%20cream%20charcoal%20and%20muted%20green%20tones%20professional%20corporate%20aesthetic%20minimal%20clean&width=1800&height=1100&seq=vantory-cta-bg&orientation=landscape"
            alt="Digital solutions"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/30 to-ink/20" />

          {/* Top-left title */}
          <div className="absolute top-10 md:top-14 left-6 md:left-12 right-6 md:right-12">
            <span className="text-xs uppercase tracking-widest2 text-cream/80">Start your project</span>
            <h2 className="text-display text-cream text-5xl md:text-7xl lg:text-[96px] leading-[0.95] mt-4 text-balance max-w-3xl">
              Let&apos;s build
              <br />
              something <span className="italic font-light">great</span> together.
            </h2>
          </div>

          {/* Bottom-right description */}
          <div className="hidden md:block absolute bottom-10 right-10 max-w-sm text-right">
            <p className="text-cream/85 text-base md:text-lg leading-relaxed">
              Free consultation. No commitment. We&apos;ll analyze your needs and propose
              the right solution for your business.
            </p>
          </div>

          {/* Bottom-left CTA */}
          <div className="relative z-10 p-6 md:p-12 w-full flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <Link
              to="/contact"
              className="group inline-flex items-center gap-3 rounded-full bg-cream text-ink pl-7 pr-2 py-2 text-sm font-semibold uppercase tracking-widest2 cursor-pointer whitespace-nowrap hover:bg-lime-accent transition-colors"
            >
              Get in touch
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-ink text-cream group-hover:rotate-[-45deg] transition-transform duration-300">
                <i className="ri-arrow-right-line text-base" />
              </span>
            </Link>

            <div className="md:hidden text-cream/85 text-sm">
              Free consultation. No commitment. We&apos;ll analyze your needs and propose the right solution.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}